import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmsFailed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 9,
			r: 8,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.1,
			y: 4.25,
			width: 1.8,
			height: 6,
			rx: .9,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 12.9,
			r: 1,
			fill: "currentColor"
		})
	]
});
export default SvgSmsFailed;
